require('./sctChoiceCards.scss');

const sctChoiceCards = angular.module('app.sct.sctChoiceCards', []);

sctChoiceCards.component('sctChoiceCards', {
  bindings: {
    options: '=',
    settings: '<',
    disabled: '<'
  },
  controller: [sctChoiceCardsCtrl],
  controllerAs: 'vm',
  template: require('./sctChoiceCards.html')
});

function sctChoiceCardsCtrl() {
  const vm = this;
  vm.select = select;
  vm.settings = vm.settings || { view: 'horizontal' };

  function select(selectedItem) {
    vm.options.map((item) => {
      item.selected = false;
      return item;
    });

    selectedItem.selected = true;
  }
}

export default sctChoiceCards;


// WEBPACK FOOTER //
// ./src/components/sct/sctChoiceCards/sctChoiceCards.js